import script from "./OnlineChatShowAnimationBlockForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnlineChatShowAnimationBlockForm.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__